import { createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createStaticVNode as _createStaticVNode, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "card bg-white border-0 rounded-3 overflow-hidden mb-4" }
const _hoisted_2 = { class: "card-body p-4" }
const _hoisted_3 = { style: {"left":"0","right":"0","bottom":"-41px","position":"absolute","margin-left":"-12px","margin-right":"-10px"} }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_apexchart = _resolveComponent("apexchart")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _cache[0] || (_cache[0] = _createStaticVNode("<div class=\"d-flex justify-content-between align-items-center flex-wrap gap-3 mb-4\"><h3 class=\"mb-0\">Response Time</h3><select class=\"form-select month-select form-control p-0 h-auto border-0 w-99\" style=\"background-position:right 0 center;\" aria-label=\"Default select example\"><option selected>Last 30 Days</option><option value=\"1\">Last 40 Days</option><option value=\"2\">Last 50 Days</option><option value=\"3\">Last 60 Days</option><option value=\"4\">Last 90 Days</option></select></div><div class=\"position-relative\" style=\"height:136px;\"><p class=\"d-flex align-items-center mb-0 justify-content-center gap-1\"><span class=\"fs-18 fw-bold text-body\">1</span> hrs <span class=\"fs-18 fw-bold text-body\">:22</span> mins </p></div>", 2)),
      _createElementVNode("div", _hoisted_3, [
        (_ctx.isClient)
          ? (_openBlock(), _createBlock(_component_apexchart, {
              key: 0,
              type: "area",
              height: "205",
              options: _ctx.responseTime,
              series: _ctx.time
            }, null, 8, ["options", "series"]))
          : _createCommentVNode("", true)
      ])
    ])
  ]))
}